import { Shimmer } from '@components'
import React from 'react'
import styled from 'styled-components'

interface Props {
  /** Label bar width as a percentage of the row (typical menu text ~50%). */
  width?: number
  isNarrow?: boolean
}

const MENU_SHIMMER_BG = 'rgba(255, 255, 255, 0.08)'

export const MenuItemShimmer: React.FC<Props> = ({ width = 50, isNarrow = false }) => {
  return (
    <SkeletonRow $isNarrow={isNarrow}>
      <Shimmer
        width="1rem"
        height="1rem"
        borderRadius="0.25rem"
        backgroundColor={MENU_SHIMMER_BG}
      />
      {!isNarrow && (
        <Shimmer
          width={`${width}%`}
          height="0.85rem"
          borderRadius="0.25rem"
          backgroundColor={MENU_SHIMMER_BG}
        />
      )}
    </SkeletonRow>
  )
}

const SkeletonRow = styled.div<{ $isNarrow: boolean }>`
  display: flex;
  align-items: center;
  justify-content: ${({ $isNarrow }) => ($isNarrow ? 'center' : 'flex-start')};
  gap: ${({ theme }) => theme.spacing.sm}rem;
  min-height: 2.6rem;
  margin: ${({ theme }) => theme.spacing.xxs}rem;
  padding: ${({ theme }) => `${theme.spacing.sm}rem ${theme.spacing.md}rem`};
  box-sizing: border-box;

  @media (max-width: 1024px) {
    min-height: 2.2rem;
    padding: ${({ theme }) => `${theme.spacing.xs}rem ${theme.spacing.sm}rem`};
  }
`
